import type React from 'react';

const handleChange = <T extends object>(
  e: React.ChangeEvent<
    HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  >,
  setFormData: React.Dispatch<React.SetStateAction<T>>,
  onChange?: (updated: Partial<T>) => void
): void => {
  const { id, value } = e.target;

  let newValue: string | number | boolean | string[] | undefined = value;

  if (e.target instanceof HTMLInputElement) {
    if (e.target.type === 'checkbox') {
      newValue = e.target.checked; // Handle checkboxes
    } else if (e.target.dataset?.type === 'decimal') {
      if (value === '') {
        newValue = undefined;
      } else if (value.endsWith('.') || value === '-' || value === '-.') {
        newValue = value;
      } else {
        newValue = Number(value);
      }
    } else if (e.target.type === 'number') {
      newValue = value === '' ? '' : Number(value); // Better number handling
    } else if (e.target.type === 'richtext') {
      newValue = value; // Handle richtext (value is already HTML string)
    } else if (e.target.type === 'multiselect') {
      newValue = value as unknown as string[]; // Handle multiselect (value is string array)
    }
  } else if (e.target instanceof HTMLSelectElement) {
    newValue = value;
  }

  setFormData((prev) => ({
    ...prev,
    [id]: newValue,
  }));

  // Notify parent
  if (onChange) {
    const updatedField = { [id]: newValue } as Partial<T>;
    onChange(updatedField);
  }

};

export default handleChange;
